import { FC, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { BasicTable } from '../BasicTable'
import ArrayInput from '../form/ArrayInput'
import { propsInterfaceFormGroupInput } from '../form/FormGroupInput'
import { AgGridTable } from '../agGridTable/AgGridTable'
import { ColDef, ColGroupDef, ServerSideStoreType } from 'ag-grid-community'
import { useFormikContext } from 'formik'

const AlertModal: FC<AlertModalProps> = (props) => {
  const { values, validateForm, touched, setFieldValue, resetForm } = useFormikContext<any>() || [] //Array vacio para solucionar el error al eliminar items de los mantenedores
  const [show, setShow] = useState(props.show)
  let styleGrid: any = {
    height: '100%',
    width: '100%',
  }
  if (props.hideGrid) {
    styleGrid = {
      display: 'none',
    }
  }

  return (
    <>
      <Modal
        size={props.size || 'xl'}
        show={show}
        onHide={props.close}
        fullscreen={props.modalFullscreen}
      >
        {props.showHeader && (
          <Modal.Header closeButton>
            <Modal.Title>{props.title || 'Mensaje'}</Modal.Title>
          </Modal.Header>
        )}

        {props.showBody && (
          <Modal.Body>
            {props.message && props.message != '' && (
              <p style={{ fontWeight: '500' }}>{props.message}</p>
            )}
            {props.arrayInput ? (
              props.arrayInput.length > 0 ? (
                <ArrayInput classContainer={props.classArrayInput} arrayInput={props.arrayInput} />
              ) : null
            ) : null}
            {props.showAddButton === true && (
              <button
                type='button'
                className='btn btn-primary btn-sm'
                onClick={() => {
                  return props.addButton
                    ? props.addButton(values, validateForm, touched, resetForm, setFieldValue)
                    : undefined
                }}
              >
                Agregar
              </button>
            )}

            {props.innerHTML ? props.innerHTML() : null}
            <div>
              {props.tableType && props.tableType === 'basic' && (
                <BasicTable edit={props.showTable} colum={props.colum} rows={props.rows} />
              )}
              {props.columnDefs !== undefined && props.columnDefs.length > 0 && (
                <div
                  className='mt-3'
                  style={styleGrid}
                >
                  <AgGridTable
                    setAGGridRef={props.setAGGridRef}
                    columnDefs={props.columnDefs}
                    isRefreshGrid={props.isRefreshGrid}
                    rowHeight={90}
                    dataRow={props.dataRow}
                    serverSideStoreType={props.serverSideStoreType}
                    pagination={props.pagination}
                    paginationPageSize={props.paginationPageSize}
                    rowClassRules={props.tableConditionalRowStyles}
                    suppressRowClickSelection={props.suppressRowClickSelection}
                    rowSelection={props.rowSelection}
                    onClick={props.onClick}
                    onChange={props.onChange}
                    onGridReady={props.onGridReady}
                    onFirstDataRendered={props.onFirstDataRendered}
                  />
                </div>
              )}
            </div>
          </Modal.Body>
        )}

        {props.showFooter && (
          <Modal.Footer>
            {props.showClose && (
              <Button
                variant='danger'
                onClick={() => {
                  return props.close ? props.close(props) : null
                }}
              >
                {props.closeName || 'Cancelar'}
              </Button>
            )}

            {props.showThirdAction && (
              <Button
                type='submit'
                disabled={props.formikProps?.isSubmitting}
                variant='primary'
                onClick={() => {
                  return props.thirdAction ? props.thirdAction(props) : null
                }}
              >
                {props.thirdActionName || 'Third Action'}
              </Button>
            )}

            {props.showSecondAction && (
              <Button
                type='submit'
                disabled={props.formikProps?.isSubmitting}
                variant='primary'
                onClick={() => {
                  return props.secondAction ? props.secondAction(props) : null
                }}
              >
                {props.secondActionName || 'Secund Action'}
              </Button>
            )}

            {props.showSave && (
              <Button
                type='submit'
                disabled={props.formikProps?.isSubmitting}
                variant='primary'
                onClick={() => {
                  return props.save ? props.save(props) : null
                }}
              >
                {props.saveName || 'Guardar'}
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </>
  )
}
AlertModal.defaultProps = {
  show: false,
  arrayInput: [],
  showClose: true,
  showSave: true,
  showHeader: true,
  showBody: true,
  showFooter: true,
  showAddButton: false,
  isRefreshGrid: true,
  addButton: undefined,
  modalFullscreen: false,
  showSecondAction: false,
  showThirdAction: false,
}
export interface AlertModalProps {
  show?: boolean
  maxLength?: string,
  isRefreshGrid?: boolean
  isAddButton?: boolean
  innerHTML?(): void
  initialValues?: any
  close?(value?: any, setFieldValue?: any, formikProps?: any): void
  open?(): void
  onGridReady?: any
  onFirstDataRendered?(params: any): void | undefined
  showAddButton?: boolean
  addButton?(
    values: any,
    validateForm: any,
    touched: any,
    errors: any,
    setFieldValue: any
  ): void | undefined | null
  save?(value: any, setFieldValue?: any, formikProps?: any, params?: any): void
  showClose?: boolean
  showSave?: boolean
  title?: string
  validationSchema?: any
  message?: string
  saveName?: string
  formikProps?: any
  readonly?: boolean
  closeName?: string
  arrayInput?: propsInterfaceFormGroupInput[] | []
  size?: 'sm' | 'lg' | 'xl'
  showTable?: boolean
  colum?: any
  rows?: any[]
  setAGGridRef?: any
  classArrayInput?: string
  tableType?: 'basic' | 'datatable'
  dataTableProps?: any
  modalFullscreen?: any
  tableConditionalRowStyles?: any
  tableSelectableRows?: any
  columnDefs?: (ColDef | ColGroupDef)[] | undefined
  dataRow?: any
  serverSideStoreType?: ServerSideStoreType
  pagination?: boolean
  paginationPageSize?: number
  showHeader?: boolean
  showBody?: boolean
  showFooter?: boolean
  showSecondAction?: boolean
  secondActionName?: string
  secondAction?(value: any, setFieldValue?: any, formikProps?: any): void
  showThirdAction?: boolean
  thirdActionName?: string
  thirdAction?(value: any, setFieldValue?: any, formikProps?: any): void
  hideGrid?: boolean
  suppressRowClickSelection?: boolean
  rowSelection?: string
  onClick?(selectedRows: any, gridRef: any, event: any): void
  onChange?(row: any, dataGrid: any, event: any): void | undefined
  onChangeFile?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any
  onClearFile?(setFieldValue: any, values: any, arrayInput: any): any
  fileRef?: any
  color?: any
  onChangeColor?(
    color: any,
    e: any,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any
  onFirstDataRendered?(params: any): void | undefined
}
export { AlertModal }
